import DetailsBasicInfoSection from './DetailsBasicInfoSection';
import { DetailsBasicInfoSectionProps, DetailsBasicInfoSectionValueProps } from './types';

export type { DetailsBasicInfoSectionProps, DetailsBasicInfoSectionValueProps };
export default DetailsBasicInfoSection;
